import React from 'react';

import { IAppProvider } from './types/corpclub-type';
import BeneficiariesDataContextStorage from './BeneficiariesDataContext';

const AppContext = ({ children }: IAppProvider): JSX.Element => (
  <BeneficiariesDataContextStorage>{children}</BeneficiariesDataContextStorage>
);

export default AppContext;
